'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Expander = function Expander(_ref) {
    var expanded = _ref.expanded,
        id = _ref.id,
        children = _ref.children,
        className = _ref.className;
    return _react2.default.createElement("div", { className: (0, _classnames2.default)(['luna-expander', className, { 'is-open': expanded }]), "aria-hidden": !expanded, id: id }, expanded && children);
};
Expander.propTypes = {
    expanded: _propTypes2.default.bool.isRequired,
    id: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
    className: _propTypes2.default.string.isRequired
};
exports.default = Expander;
//# sourceMappingURL=Expander.js.map